const apiUrl = process.env.REACT_APP_API_URL;
export const addSubCategory = async(categoryId, name) => {
    const token = sessionStorage.getItem('token');
    const url =  `${apiUrl}/api/configs/addSubCategory`;       
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify({
            categoryId,
            name
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}

export const getAllSubCategories = async(id) => {
    const url =  `${apiUrl}/api/configs/getAllSubCategories/${id}`;       
    const token = sessionStorage.getItem('token');
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}

export const getSubCategory = async(id) => {
    const url =  `${apiUrl}/api/configs/getSubCategory/${id}`;     
    const token = sessionStorage.getItem('token');  
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return {}
    }
}



export const updateSubCategory = async(id, categoryId, name, isActive) => {
    const url =  `${apiUrl}/api/configs/updateSubCategory`;       
    const token = sessionStorage.getItem('token');
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
         },
        body: JSON.stringify({
            id, categoryId, name, isActive
        })
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}